/**
 * Used for accessibility.
 * If an error returned from backend contains a translations key
 * formatted like this (translation_key), it will use translate to return
 * the correct language translation, based on resource + translation key.
 */
export function translateBackendError(
  { resource, error }: { resource: string; error: string },
  translate: (translation: string) => string,
) {
  const matchErrorWithTranslationKey = error.match(/\([a-z_]+\)/);

  if (!matchErrorWithTranslationKey) {
    return error;
  }

  const errorTranslated = translate(
    `${resource}.${matchErrorWithTranslationKey[0].replace(/[()]/g, '')}`,
  );

  return errorTranslated.includes('resources.') ? error : errorTranslated;
}
